
<div>
    @if (this.data) {
    <div class="card-container">
        <mat-card class="status-card" [routerLink]="routerLink">
            <div class="card-heading">Total Creditors</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.creditors.totalCreditors, 0)}}
            </div>
            <div class="footer">
                Total Owed
            </div>
        </mat-card>

        <mat-card class="status-card" [routerLink]="forApprovalLink">
            <div class="card-heading">For Approval</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.creditors.forApproval, 0)}}
            </div>
            <div class="footer">
                Invoices awaiting approval to be paid
            </div>
        </mat-card>

        <mat-card class="status-card" [routerLink]="accrualLink">
            <div class="card-heading">Accruals</div>
            <div class="content currency">
                {{nrHelper.toFormattedCurrency(+data.creditors.accruals, 0)}}
            </div>
            <div class="footer">
                Money committed, invoice not received
            </div>
        </mat-card>

        <mat-card class="status-card" [routerLink]="routerLink">
            <div class="card-heading">Nett Cash</div>
            <div class="content currency">
                <span [ngClass]="+data.creditors.cashAvailable < 0 ? 'redText' : null">{{nrHelper.toFormattedCurrency(+data.creditors.cashAvailable, 0)}}</span>
            </div>
            <div class="footer">
                Cash left after paying all creditors and accruals
            </div>
        </mat-card>            
    </div>
    }
</div>